export default __webpack_public_path__ + "static/media/processStep.55baf285.svg";